import Vue from "vue";
import Vuex from "vuex";
import { getFolderDetails, getPanelist } from "../../utils/apiFunctions";

Vue.use(Vuex);

const state = () => ({
  activeFolderID: "",
  modalType: "",
  activeFolderContent: {},
  folderExpand: [],
  selectedFolderID: [],
  selectedUserID: [],
  panelFolder: "",
});

const getters = {
  getActiveFolderID: (state) => state.activeFolderID,
  getModalType: (state) => state.modalType,

  getActiveFolder: (state) => state.activeFolderContent,
  getExpandList: (state) => state.folderExpand,
  getSelectedFolderIDs: (state) => state.selectedFolderID,
  getSelectedUsers: (state) => state.selectedUserID,
};

const actions = {
  async getSelectedFolder(state, payload) {
    const response = await getFolderDetails(payload);

    let check = payload.flag;
    if (check) {
      delete payload.flag;
    }
    if (response.status == 200) {
      let data = response.data.data.content;
      for (let user in data.users) {
        data.users[user].folderID = data.folderID;
      }
      if (!check) {
        state.commit("setActiveFolder", data);
      }
    }
    return response;
  },
  async getPanelists(state, payload) {
    const response = await getPanelist(payload);
    let check = payload.flag;
    if (check) {
      delete payload.flag;
    }
    if (response.status == 200) {
      let data = response.data.data.content;
      for (let user in data.users) {
        data.users[user].folderID = data.folderID;
      }
      if (!check) {
        state.commit("setActiveFolder", data);
      }
    }
    return response;
  },
};

const mutations = {
  setActiveFolderID(state, folderID) {
    state.activeFolderID = folderID;
  },
  setModalType(state, payload) {
    state.modalType = payload;
  },
  setActiveFolder(state, folder) {
    state.activeFolderContent = folder;
  },
  saveSelectedUsers(state, users) {
    state.selectedUserID = [...users];
  },
  saveSelectedFolders(state, folders) {
    state.selectedFolderID = [...folders];
  },
  addExpand(state, payload) {
    state.folderExpand.push({
      folderID: payload.folderID,
      expand: payload.expand,
      level: payload.level,
    });
  },
  flipExpand(state, payload) {
    state.folderExpand[payload.index].expand = payload.flag;
  },
  resetExpand(state) {
    state.folderExpand = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
